import { Card, Typography, Divider } from '@mui/material';
import React from 'react';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import Logo from '../../../Assets/Images/MotiLogo2.png';

export default function WelcomeNote() {
  return (
    <Gene20Box>
      <Typography variant="h2" align="center" sx={{ letterSpacing: '8px' }}>
        welcome to moti
      </Typography>
      <Divider />
      <img src={Logo} height="40vh" width="100%" align="center" sx={{}} />
    </Gene20Box>
  );
}
